import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SubmittedApplicationListingService } from '../submitted-application-listing/services/submitted-application-listing.service';
import { SearchResponse } from 'src/app/angular-elements/producer/interfaces/search-response.interface';
import { Subscription } from 'rxjs';
import { ApplicationRecord } from 'src/app/angular-elements/producer/interfaces/application-record.interface';
import { ApplicationStatusRetrievalService } from 'src/app/shared/services/application-status-retrieval.service';
import { PtlWindowLocationService } from '@ptl/global-components';

@Component({
    selector: 'app-application-status-listing',
    templateUrl: './application-status-listing.component.html',
    styleUrls: ['./application-status-listing.component.scss'],
    standalone: false
})
export class ApplicationStatusListingComponent implements OnInit, OnDestroy {

  @Input() content: { [contentKey: string]: string | boolean } = {
    appStatusContentOne: undefined,
    appStatusContentTwo: undefined,
    appStatusContentThree: undefined
  };
  @Input() viewUrl: string;
  retrievedInfo: SearchResponse;

  retrievedResponseSubscription: Subscription;

  someAppsSubmitted: boolean;

  constructor(
    private submittedApplicationService: SubmittedApplicationListingService,
    private applicationStatusRetrievalService: ApplicationStatusRetrievalService,
    private windowLocationService: PtlWindowLocationService
  ) { }

  async ngOnInit() {
    this.retrievedResponseSubscription = this.submittedApplicationService.retrievedApps$.subscribe( response => {
      if (response) {
        this.retrievedInfo = response;
        this.someAppsSubmitted = response.searchedApplications.some( plan => plan.downstreamTrackingStatus !== null);
      }
    });
    this.submittedApplicationService.getApps();
  }

  ngOnDestroy() {
    if (this.retrievedResponseSubscription) {
      this.retrievedResponseSubscription.unsubscribe();
    }
  }

  trackByAppId(index: number, plan: ApplicationRecord): string {
    return plan.applicationTrackingId;
  }

  async retrieveApp(trackingId: string) {
    const valuesSaved: boolean
      = await this.applicationStatusRetrievalService.applyRetrievedDataToState(trackingId, '');

    if (valuesSaved && this.viewUrl) {
      this.windowLocationService.goToUrl(this.viewUrl);
    }
  }

}
